import Edid from './edidClass'

/* eslint-disable */

function convertToIntArray (stringArray) {
  return stringArray.map(v => parseInt(v, 16))
}

export default function parseEDID (str) {
  let edid = new Edid()
  let wordArray = str.split('')
  let hexArray = []
  wordArray.forEach((w, i) => {
    if (i % 2 === 0) {
      hexArray.push(w + wordArray[i + 1])
    }
  })
  let intArr = convertToIntArray(hexArray)
  edid.setEdidData(intArr)
  edid.parse()

  let treedata = []

  let block0 = {
    label:"Block 0",
    id:"tBlock0",
    children: []
  }

  let headerInfo = {
    label:"Header Information",
    id: "tHeaderInfo",
    url:'partials/block0/edidHeaderInfo.html',
    "children" : []
  }
  block0.children.push(headerInfo)

  let bdp = {
    label:"Basic Display Parameters",
    id:"tBDP",
    url:'partials/block0/basicDisplayParameters.html',
    "children":[]
  }

  block0.children.push(bdp)

  let chromaticityCoords = {label:"Chromaticity Coordinates",
    id:"tchromaticityCoords",
    url:'partials/block0/chromacityCoords.html',
    "children" : []
  }
  block0.children.push(chromaticityCoords)

  let timingBitmap = {
    label:"Timing Bitmap",
    id:"tTimingBitmap",
    url:'partials/block0/timingBitmap.html',
    "children" : []
  }
  block0.children.push(timingBitmap)

  let standardTimingInfo = {
    label:"Standard Timing Information",
    id: "tStandardTimingInfo",
    "children" : []
  }

  let standardDisplayModes = {
    label:"Standard Display Modes",
    id: "role151",
    url:'partials/block0/stdDisplayModes.html',
    "children" : []
  }
  standardTimingInfo.children.push(standardDisplayModes)

      // For Each Block 0 Descriptor
  for(let index = 0; index < edid.dtds.length; index++)
  {
    let descriptorNumber = index + 1
    let descriptor = {
      label:"Descriptor " + descriptorNumber,
      id: "block0Descriptor"+descriptorNumber,
      url:'partials/block0/detailedTimingDescriptors.html',
      "children" : []
    }
    standardTimingInfo.children.push(descriptor)
  }

  // Add Standard Timing Info to Block 0
  block0.children.push(standardTimingInfo)
  for(let index = 0; index < edid.exts.length; index++) {
    let blockNumber = index + 1
    let blockLabel = "Block " + blockNumber
    let id = "tBlock" + blockNumber;

    // Add Block
    let blockX = {
      label:blockLabel,
      id:id,
      children: []
    }

    let extHeader = {
      label:"Extenstion Header Information",
      id: id+"ExtensionHeaderInfo",
      url:'partials/blockX/extHeader.html',
      "children" : []
    }
    blockX.children.push(extHeader)

    // If there is a collection of data blocks in this extension
    if(edid.exts[index].dataBlockCollection)
    {
      let ceaDataBlock = {label:"CEA Data Block",
                      id: id+"CeaDataBlock",
                      "children" : []}
      // For Each CEA Data Block
      for(let ceaIndex = 0; ceaIndex < edid.exts[index].dataBlockCollection.length; ceaIndex++) {
        let dataBlock = edid.exts[index].dataBlockCollection[ceaIndex];
        let treeDataBlock = {}
        if(dataBlock.tag == edid.dataBlockType.RESERVED) {
          treeDataBlock = {label:"Reserved Data Block",
                            id: id+edid.dataBlockType.RESERVED.string+ceaIndex,
                            url:'partials/blockX/dataBlocks/reserved.html',
                            "children" : []}
        } else if(dataBlock.tag == edid.dataBlockType.AUDIO) {
          treeDataBlock = {label:"Audio Data Block",
                            id: id+edid.dataBlockType.AUDIO.string+ceaIndex,
                            url:'partials/blockX/dataBlocks/audio.html',
                            "children" : []}
        } else if(dataBlock.tag == edid.dataBlockType.VIDEO) {
          treeDataBlock = {label:"Video Data Block",
                            id: id+edid.dataBlockType.VIDEO.string+ceaIndex,
                            url:'partials/blockX/dataBlocks/video.html',
                            "children" : []}
        } else if(dataBlock.tag == edid.dataBlockType.VENDOR_SPECIFIC) {
          if (dataBlock.ieeeIdentifier == edid.ieeeOuiType.HDMI14.value) {
            treeDataBlock = {label:"Vendor Specific Data Block HDMI 1.4",
                              id: id+edid.dataBlockType.VENDOR_SPECIFIC.string+ceaIndex,
                              url:'partials/blockX/dataBlocks/vendorSpecificHDMI14.html',
                              "children" : []}
          } else if (dataBlock.ieeeIdentifier == edid.ieeeOuiType.HDMI20.value) {
            treeDataBlock = {label:"Vendor Specific Data Block HDMI 2.0",
                              id: id+edid.dataBlockType.VENDOR_SPECIFIC.string+ceaIndex,
                              url:'partials/blockX/dataBlocks/vendorSpecificHDMI20.html',
                              "children" : []}
          } else {
            treeDataBlock = {label:"Vendor Specific Data Block",
                            id: id+edid.dataBlockType.VENDOR_SPECIFIC.string+ceaIndex,
                            url:'partials/blockX/dataBlocks/vendorSpecific.html',
                            "children" : []}
          }
        } else if(dataBlock.tag == edid.dataBlockType.SPEAKER_ALLOCATION) {
          treeDataBlock = {label:"Speaker Allocation Data Block",
                          id: id+edid.dataBlockType.SPEAKER_ALLOCATION.string+ceaIndex,
                          url:'partials/blockX/dataBlocks/speakerAllocation.html',
                          "children" : []}
        } else if(dataBlock.tag == edid.dataBlockType.EXTENDED_TAG) {
          if (dataBlock.extendedTag == edid.extendedDataBlockType.VIDEO_CAPABILITY) {
            treeDataBlock = {label:"Video Capability Data Block",
                              id: id+edid.dataBlockType.EXTENDED_TAG.string+ceaIndex,
                              url:'partials/blockX/dataBlocks/videoCapability.html',
                              "children" : []}
          }
          else if (dataBlock.extendedTag == edid.extendedDataBlockType.COLORIMETRY) {
            treeDataBlock = {label:"Colorimetry Data Block",
                              id: id+edid.dataBlockType.EXTENDED_TAG.string+ceaIndex,
                              url:'partials/blockX/dataBlocks/colorimetry.html',
                              "children" : []}
          }
          else if (dataBlock.extendedTag == edid.extendedDataBlockType.YCBCR420_VIDEO) {
            treeDataBlock = {label:"YCbCr 4:2:0 Video Data Block",
                              id: id+edid.dataBlockType.EXTENDED_TAG.string+ceaIndex,
                              url:'partials/blockX/dataBlocks/YCbCr420Video.html',
                              "children" : []}
          }
          else if (dataBlock.extendedTag == edid.extendedDataBlockType.YCBCR420_CAPABILITY_MAP) {
            treeDataBlock = {label:"YCbCr 4:2:0 Capability Map Data Block",
                              id: id+edid.dataBlockType.EXTENDED_TAG.string+ceaIndex,
                              url:'partials/blockX/dataBlocks/YCbCr420CapabilityMap.html',
                              "children" : []}
          } else {
            treeDataBlock = {label:"Extended Tag Data Block",
                              id: id+edid.dataBlockType.EXTENDED_TAG.string+ceaIndex,
                              url:'partials/blockX/dataBlocks/extended.html',
                              "children" : []}
          }
        }
        ceaDataBlock.children.push(treeDataBlock)
      }
      blockX.children.push(ceaDataBlock)
    }

    // For each extension DTD, build the tree object then add it to blockX
    for(let extDtdIndex = 0; extDtdIndex < edid.exts[index].dtds.length; extDtdIndex++)
    {
      // let dtd = edid.exts[index].dtds[extDtdIndex];
      let dtdNumber = extDtdIndex + 1
      let dtdTree = {
        label:"Detailed Timing Descriptor "+dtdNumber,
        id: id+"Dtd"+dtdNumber,
        url:'partials/blockX/extDtds.html',
        "children" : []
      }
      blockX.children.push(dtdTree)
    }
    treedata.push(blockX)
  }
  return edid
}
/* header
  XXX: Valid Checksum: {{validChecksums[0]}}
  EDID Header: d.validHeader
  EISA ID: d.eisaId
  Product Code: d.productCode.toString(16).toUpperCase()
  Serial Number: d.serialNumber
  Manufacture Date: d.manufactureDate
  EDID Version: d.edidVersion
  Number of Extensions: d.numberOfExtensions
  Checksum: 0x d.checksum.toString(16).toUpperCase
*/

/* Basic Display Parameters

  Digital Input: d.bdp.digitalInput
  Compatible with VESA DFP: d.bdp.vesaDfpCompatible
  Maximum Horizontal Image Size: d.bdp.maxHorImgSize
  Maximum Vertical Image Size: d.bdp.maxVertImgSize
  Display Gamma: d.bdp.displayGamma.toFixed(2)
  DPMS Standby: edid.bdp.dpmsStandby
  DPMS Suspend: edid.bdp.dpmsSuspend
  DPMS Active-Off: edid.bdp.dpmsActiveOff
  Display Type: edid.digitalColorSpace[edid.bdp.displayType]
  Standard sRGB Color Space: edid.bdp.standardSRgb
  Preferred Timing Mode: edid.bdp.preferredTiming
  GTF Supported: edid.bdp.gtfSupported

  XXX IF analogBDP edid.bdp.digitalInput
    Digital Input: edid.bdp.digitalInput
    Video white and sync levels, relative to blank: edid.WhiteAndSyncLevels[edid.bdp.whiteSyncLevels]
    Blank-to-black setup (pedestal) expected: edid.bdp.blankToBlack
    Separate sync supported: edid.bdp.separateSyncSupported
    Composite sync (on HSync) supported: edid.bdp.compositeSyncSupported
    Sync on green supported: edid.bdp.synOnGreen
    VSync pulse must be serrated: edid.bdp.vsyncSerrated
    Maximum Horizontal Image Size: edid.bdp.maxHorImgSize
    Maximum Vertical Image Size: edid.bdp.maxVertImgSize
    Display Gamma: edid.bdp.displayGamma.toFixed(2)
    DPMS Standby: edid.bdp.dpmsStandby
    DPMS Suspend: edid.bdp.dpmsSuspend
    DPMS Active-Off: edid.bdp.dpmsActiveOff
    Display Type: edid.digitalColorSpace[edid.bdp.displayType]
    Standard sRGB Color Space: edid.bdp.standardSRgb
    Preferred Timing Mode: edid.bdp.preferredTiming
    GTF Supported: edid.bdp.gtfSupported
*/

/*

Chromaticity Coordinates

  Red X: {{edid.chromaticity.redXCoords.toFixed(3)}}
  Red Y: {{edid.chromaticity.redYCoords.toFixed(3)}}
  Green X: {{edid.chromaticity.greenXCoords.toFixed(3)}}
  Green Y: {{edid.chromaticity.greenYCoords.toFixed(3)}}
  Blue X: {{edid.chromaticity.blueXCoords.toFixed(3)}}
  Blue Y: {{edid.chromaticity.blueYCoords.toFixed(3)}}
  White X: {{edid.chromaticity.whiteXCoords.toFixed(3)}}
  White Y: {{edid.chromaticity.whiteYCoords.toFixed(3)}}

*/

/*

Timing Bitmap

  tb in edid.establishedTimingBitmaps
    checked = isTimingBitmapSet($index)
    {{tb}}
*/

/*
Standard Display Modes
  dispMode in edid.standardDisplayModes
    X Resolution: {{dispMode.xResolution}}
    X:Y Pixel Ratio: {{edid.xyPixelRatioEnum[dispMode.xyPixelRatio].string}}
    Vertical Frequency: {{dispMode.vertFreq}}
*/

/*
Detailed Timing Descriptor   (Descriptor 1~2)
  Pixel Clock: {{dtd.pixelClock}}MHz
  Horizontal Active: {{dtd.horActivePixels}}
  Horizontal Blanking: {{dtd.horBlankPixels}}
  Vertical Active: {{dtd.vertActivePixels}}
  Vertical Blanking: {{dtd.vertBlankPixels}}
  Horizontal Sync Offset: {{dtd.horSyncOff}}
  Horizontal Sync Pulse: {{dtd.horSyncPulse}}
  Vertical Sync Offset: {{dtd.vertSyncOff}}
  Vertical Sync Pulse: {{dtd.vertSyncPulse}}
  Horizontal Display Size: {{dtd.horDisplaySize}}
  Vertical Display Size: {{dtd.vertDisplaySize}}
  Horizontal Border: {{dtd.horBorderPixels}}
  Vertical Border: {{dtd.vertBorderLines}}
  Interlaced: {{dtd.interlaced}}
  Stereo Mode: {{dtd.stereoMode}}
  Sync Type: {{dtd.syncType}}
  <span ng-show="dtd.syncType == edid.syncTypeEnum.DIGITAL_SEPARATE">
      Vertical Sync Polarity: {{dtd.vSyncPolarity}}
  </span>
  <span ng-show="dtd.syncType != edid.syncTypeEnum.DIGITAL_SEPARATE">
      Vertical Sync Serrated: {{dtd.vSyncSerrated}}
  </span>

  <span ng-show="(dtd.syncType == edid.syncTypeEnum.ANALOG_COMPOSITE) ||
                  (dtd.syncType == edid.syncTypeEnum.BIPOLAR_ANALOG_COMPOSITE)">
      Sync on all 3 RGB lines: {{dtd.syncAllRGBLines}}
  </span>
  <span ng-show="(dtd.syncType != edid.syncTypeEnum.ANALOG_COMPOSITE) &&
                  (dtd.syncType != edid.syncTypeEnum.BIPOLAR_ANALOG_COMPOSITE)">
      HSync polarity: {{dtd.hSyncPolarity}}
  </span>
  2-Way Line-Interleaved Stereo: {{dtd.twoWayStereo}}
*/

/*
  Extension Header Information
  Valid Checksum: {{validChecksums[ext.blockNumber]}}
  Extension Tag: {{ext.extTag}}
  Revision Number: {{ext.revisionNumber}}
  DTD Start: 0x{{ext.dtdStart.toString(16).toUpperCase()}}
  Number of Native DTDs: {{ext.numDtds}}
  Supports Underscan: ext.underscan
  Supports Basic Audio: ext.basicAudio
  Supports YcBcR 4:4:4: ext.ycbcr444
  Supports YcBcR 4:2:2: ext.ycbcr422
  Checksum: 0x{{ext.checksum.toString(16).toUpperCase()}}
*/

/*
  Video Data Block
  ng-repeat="shortVideoDescriptor in ceaDataBlock.shortVideoDescriptors
    Native: {{shortVideoDescriptor.nativeResolution.toString().toUpperCase()}}
    VIC: {{edid.shortVideoDescriptors[shortVideoDescriptor.vic].vic}}
    Format: {{edid.shortVideoDescriptors[shortVideoDescriptor.vic].format}}
    Field Rate: {{edid.shortVideoDescriptors[shortVideoDescriptor.vic].fieldRate}}
    Picture AR: {{edid.shortVideoDescriptors[shortVideoDescriptor.vic].pictureAspectRatio}}
    Pixel AR: {{edid.shortVideoDescriptors[shortVideoDescriptor.vic].pixelAspectRatio}}

*/

/*
  Audio Data Block
  shortAudioDescriptor in ceaDataBlock.shortAudioDescriptors
  <div class="dataBlock" ng-include src=shortAudioDescView(shortAudioDescriptor.format)>
  </div>
</div>

*/

/*
  Speaker Allocation Data Block
  speakerAllocation in edid.speakerAllocation
    speakerAllocation
    ng-checked="isBitSet(ceaDataBlock.payload,$index)">
*/

/*
  Video Capability Data Block

  Quantization Range selectable via AVI YQ for YCC formats: ceaDataBlock.quantizationRangeYCC
  Quantization Range selectable via AVI Q for RGB formats: ceaDataBlock.quantizationRangeRGB
  Overscan underscan behaviour for Preferred Video Format: ceaDataBlock.overscanPT
  Overscan underscan behaviour for IT Video Formats: ceaDataBlock.overscanIT
  Overscan underscan behaviour for CE Video Formats: ceaDataBlock.overscanCE
*/

/*
  Colorimetry Data Block

  Supports BT2020 RGB: ceaDataBlock.supportsBT2020RGB
  Supports BT2020 YCC: ceaDataBlock.supportsBT2020YCC
  Supports BT2020 cYCC: ceaDataBlock.supportsBT2020cYCC
  Supports Adobe RGB: ceaDataBlock.supportsAdobeRGB
  Supports Adobe YCC601: ceaDataBlock.supportsAdobeYCC601
  Supports sYCC601: ceaDataBlock.supportssYCC601
  Supports xvYCC709: ceaDataBlock.supportsxvYCC709
  Supports xvYCC601: ceaDataBlock.supportsxvYCC601

  Gamut MetaData3 (MD3): {{ceaDataBlock.gamutMD3}}
  Gamut MetaData2 (MD2): {{ceaDataBlock.gamutMD2}}
  Gamut MetaData1 (MD1): {{ceaDataBlock.gamutMD1}}
  Gamut MetaData0 (MD0): {{ceaDataBlock.gamutMD0}}

*/

/*
  Vendor Specific Data Block HDMI 1.4
  IEEE OUI: {{pad(ceaDataBlock.ieeeIdentifier.toString(16).toUpperCase(),6)}} <br />
  Source Physical Address: {{ceaDataBlock.physicalAddress.toString(16).toUpperCase()}} <br />
  Supports ACP, ISRC1, ISRC2: ceaDataBlock.supportsAI
  Supports 48 bits/pixel (16 bits/color): ceaDataBlock.deepColor48
  Supports 36 bits/pixel (12 bits/color): ceaDataBlock.deepColor36

  Supports 30 bits/pixel (10 bits/color): ceaDataBlock.deepColor30

  Supports YCbCr 4:4:4 Deep Color: ceaDataBlock.deepColorY444

  Supports Dual DVI: ceaDataBlock.dualDvi
  Max TMDS Clock Rate: {{ceaDataBlock.maxTmdsRate}} MHz

  Video/Audio Latency Fields Present: ceaDataBlock.latencyPresent
  ng-show="ceaDataBlock.latencyPresent
    Video Latency: {{ceaDataBlock.videoLatency}} ms
    Audio Latency: {{ceaDataBlock.audioLatency}} ms
    Interlaced Video/Audio Latency Fields Present: {{ceaDataBlock..iLatencyPresent.toString().toUpperCase()}}
    Interlaced Video Latency: {{ceaDataBlock.iVideoLatency}} ms
    Interlaced Audio Latency: {{ceaDataBlock.iAudioLatency}} ms

*/

/*
  Vendor Specific Data Block HDMI 2.0
  IEEE OUI: {{pad(ceaDataBlock.ieeeIdentifier.toString(16).toUpperCase(),6)}}

  Version: {{ceaDataBlock.versionHF}}
  Max TMDS Clock Rate: {{ceaDataBlock.maxTmdsRateHF}} MHz

  Supports SCDC: ceaDataBlock.supportsSCDC

  Supports SCDC Read Request: ceaDataBlock.supportsSCDCRR

  Supports Scrambling for less &lt;=340MHz: ceaDataBlock.supportsLTE340scramble

  Supports 3D Independent View: ceaDataBlock.supports3DIV

  Supports 3D Dual View: ceaDataBlock.supports3DDV
  Supports 3D OSD Disparity: ceaDataBlock.supports3DOSD

  Supports 30 bits/pixel (10 bits/color) for Deep Color YCbCr 4:2:0 : ceaDataBlock.deepColorY420_30

  Supports 36 bits/pixel (12 bits/color) for Deep Color YCbCr 4:2:0 : ceaDataBlock.deepColorY420_36

  Supports 48 bits/pixel (16 bits/color) for Deep Color YCbCr 4:2:0 : ceaDataBlock.deepColorY420_48

*/
/*
  Extended Tag Data Block
  Extended Tag: {{ceaDataBlock.extendedTag}} <br />
  Block Length: {{ceaDataBlock.length}} <br />
*/

/*
  Extended Tag Data Block</h3>

  Extended Tag: {{ceaDataBlock.extendedTag}} <br />
  Block Length: {{ceaDataBlock.length}} <br />
*/

/*
  YCbCr 4:2:0 Video Data Block

  shortVideoDescriptor in ceaDataBlock.YCbCr420OnlyShortVideoDescriptors
    Native: {{shortVideoDescriptor.nativeResolution.toString().toUpperCase()}}
    VIC: {{edid.shortVideoDescriptors[shortVideoDescriptor.vic].vic}}
    Format: {{edid.shortVideoDescriptors[shortVideoDescriptor.vic].format}}
    Field Rate: {{edid.shortVideoDescriptors[shortVideoDescriptor.vic].fieldRate}}
    Picture AR: {{edid.shortVideoDescriptors[shortVideoDescriptor.vic].pictureAspectRatio}}
    Pixel AR: {{edid.shortVideoDescriptors[shortVideoDescriptor.vic].pixelAspectRatio}}

*/

// console.log(treedata[0].children)



// WEBPACK FOOTER //
// ./src/utils/edidParser.js